module.exports = "<p>The artist on<br><em>Deine Raumkapsel (Your Space Capsule)</em> 2006</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio4/content.md
// module id = 851
// module chunks = 0